import { Component, Input, Output, OnInit,OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Principal } from '../../../services/auth/principal.service';
import { AppSwitcherService } from '../../../services/service/app-switcher.service';
import { UserContextService } from '../../../services/service/user-context.service';
import { OfficeSwitcherService } from '../../../services/service/office-switcher.service';
import { SubscriptionManager } from '../../../services/service/subscription-mamager';
import { NavMenu, NavMenuItem } from '../../model/nav-menu';

@Component({
    selector: 'zx-applet-nav-map',
    templateUrl: './applet-nav-map.component.html',
    styleUrls: ['./applet-nav-map.component.css'],
})
export class AppletNavMapComponent implements OnInit,OnDestroy {

    nav: NavMenu;
    showLoading:boolean = true;

    constructor(
        public appSwitcher: AppSwitcherService,
        public officeSwitcher: OfficeSwitcherService,
        private router: Router,
        private principal: Principal,
		private userContext: UserContextService,
        private subscriptionManager: SubscriptionManager,
    ) { }

    ngOnInit(){
        this.subscriptionManager.register(this, this.userContext.dataChange.subscribe(para=>{
            if(para.key == "MainSiderMenu") this.setNavData(para.value);
        }));
        this.setNavData(this.userContext.getData("MainSiderMenu"));
    }
	ngOnDestroy(){
		this.subscriptionManager.unsubscribe(this);
    }
    
    
    private setNavData(data){
        this.nav = this.forbidden?null:data;
        setTimeout(() => {
            this.showLoading = false;
        }, 1000);
    }
    
    public get forbidden() : boolean {
        return this.appSwitcher.forbidden;
    }
    public get forbiddenMessage():string{
        const office = this.officeSwitcher.currentOffice;
        const officeTypeText = this.officeSwitcher.currentOfficeLevelText;
        if(office){
            return "您在当前"+ officeTypeText + ' [ ' + office.name +" ] 没有此应用的访问权限，可以切换"+ officeTypeText +"或切换到其它应用，如果有疑问请与管理员联系！";
        }else{
            return "您没有此应用的访问权限，如果有疑问请与管理员联系！";
        }
    }

    get currentOfficeTypeText(){
        const text = this.officeSwitcher.currentOfficeLevelText;
        return text?"切换"+text:null;
    }
    

    hasPermission(menuItem:NavMenuItem):boolean{
        return this.principal.hasAnyAuthority(menuItem.data.authorities);
    }

    changeApp(){
        this.appSwitcher.openSelector();
    }
    changeOffice(){
        this.officeSwitcher.openSelector();
    }
    login(){
        this.router.navigate(["/login"]);
        setTimeout(() => {
            this.appSwitcher.changeCurrentApp(null);
        }, 100);
    }

    go(navItem: NavMenuItem) {
        if (navItem.action) {
            if (navItem.actionType == 'sref') {
                (async () => {
                    try {
                        await this.router.navigate([navItem.routerLink], {queryParams: navItem.queryParams});
                    } catch (e) {
                        console.error("specified router link is not found: routerLink=" + navItem.routerLink);
                    }
                })();
            } else location.href = navItem.action;
        }
    }
}
